document.addEventListener('DOMContentLoaded', function() {
    const desktopReviewBtn = document.querySelectorAll('.product .jdgm-prev-badge');
    const seeAllReviewBtn = document.querySelector('.product .product__accordion .product-detail-accordion__item__all-reviews');
    const allReviewsBtns = [...desktopReviewBtn, seeAllReviewBtn].filter(Boolean);
    allReviewsBtns?.forEach(btn => {
        btn.addEventListener('click', (e) => {
            e.preventDefault();
            e.stopPropagation();
            const mainReviewsWidget = document.querySelector('#judgeme_product_reviews');
            if(mainReviewsWidget) {
                window.scrollTo({
                    top: mainReviewsWidget.offsetTop - 120,
                    behavior: 'smooth'
                });
            };
        });
    })
});